<template>
  <div
    :id="props.id"
    class="label-utility"
    :class="props.color">
    <div
      ref="label"
      class="label-utility--circle" />
    <p
      v-if="props.title !== ''"
      :id="textId"
      ref="labelText">
      {{ props.title }}
    </p>
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue'
import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'
import useUtils from '@/composables/useUtils'

gsap.registerPlugin(ScrollTrigger)

const label = ref(null)

const labelText = ref(null)
const { genUUID } = useUtils()
const labelId = genUUID()
const props = defineProps({
  title: {
    type: String,
    default: '',
  },
  textId: {
    type: String,
    default: '',
  },
  id: {
    type: String,
    default: '',
  },
  color: {
    type: String,
    default: 'purple',
  },
})

const animateLabel = () => {
  gsap.fromTo(
    label.value,
    { width: 0 },
    {
      width: '100%',
      scrollTrigger: {
        trigger: label.value,
        id: labelId,
        start: 'top-=100% bottom-=10',
        end: 'bottom bottom-=200',
        scrub: true,
        markers: false,
      },
    }
  )
}

onMounted(() => {
  animateLabel()
})

onBeforeUnmount(() => {
  ScrollTrigger.getById(labelId)?.kill()
})
</script>

<style lang="scss">
.label-utility {
  @apply relative py-[2px] px-3 rounded-3xl bg-capstan-sky w-fit overflow-hidden;

  &--circle {
    @apply absolute left-0 top-0 h-full w-full scale-110 bg-capstan-sky rounded-3xl;
  }

  p {
    @apply relative text-[14px] mb-0 text-capstan-green;
  }

  &.white {
    @apply bg-white;

    .label-utility--circle {
      @apply bg-white;
    }
  }
}
</style>
